var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackwardFaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45387 6.00003L6.52694 10.0731C6.66541 10.2116 6.73624 10.3856 6.73944 10.5952C6.74266 10.8048 6.67183 10.9821 6.52694 11.1269C6.38208 11.2718 6.20644 11.3443 6.00004 11.3443C5.79364 11.3443 5.61801 11.2718 5.47314 11.1269L0.978919 6.6327C0.885319 6.53912 0.819294 6.4404 0.780844 6.33655C0.742377 6.23272 0.723145 6.12054 0.723145 6.00003C0.723145 5.87951 0.742377 5.76734 0.780844 5.6635C0.819294 5.55965 0.885319 5.46094 0.978919 5.36735L5.47314 0.873127C5.61159 0.734661 5.78563 0.663827 5.99524 0.660627C6.20484 0.657411 6.38208 0.728244 6.52694 0.873127C6.67183 1.01799 6.74427 1.19363 6.74427 1.40003C6.74427 1.60643 6.67183 1.78206 6.52694 1.92693L2.45387 6.00003Z",
    fill: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwardFaded);
export default __webpack_public_path__ + "static/media/BackwardFaded.a2b5c75278ae515eaf932f090d922634.svg";
export { ForwardRef as ReactComponent };